module.exports = __webpack_public_path__ + "9f581ab75fc24e432d5a0902a230a044.svg";